<template>
  <div class="py-2.5 px-5 bg-white rounded-lg shadow">
    <p class="text-gray-900 text-xs">{{ title }}</p>
    <RadiusSlider :default-radius="defaultRadius" :prefix="prefix" theme="dark" @set-radius="$emit('set-radius', $event)" />
  </div>
</template>

<script lang="ts" setup>
defineProps({
  title: {
    type: String,
    required: true,
  },
  defaultRadius: {
    type: Number,
    required: true,
  },
  prefix: {
    type: String,
    default: '',
  },
})

defineEmits(['set-radius'])
</script>
